import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getRequisition = ({ churchId, id }) => {
  return axios.get(`/churches/${churchId}/requisitions/${id}`);
};

export const useRequisition = ({ churchId, id, config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["requisition", churchId, id],
    queryFn: () => getRequisition({ churchId, id })
  });
};
